module.exports = __webpack_public_path__ + "img/11_39.215023c8.png";